import { API_CACHE_KEYS } from "api/cacheKeys";
import { useCustomQuery } from "api/useCustomQuery";
import { JANZU_URL } from "config/config";
import { ReviewPageSummaryData } from "types/imageQueries";

import { BaseQueryOptions } from "../types";

export const useGetReviewPageSummary = (
  options: BaseQueryOptions<ReviewPageSummaryData> = {}
) => useCustomQuery<ReviewPageSummaryData>(
  API_CACHE_KEYS.reviewPage.summary(),
  `${JANZU_URL}reef-api/image-queries/count`,
  {
    enabled: options.enabled,
    retry: 2,
    ...options,
  }
);

export const useReviewPageService = (enabled: boolean = true) => {
  const getReviewPageSummaryQuery = useGetReviewPageSummary({ enabled });

  return {
    reviewPageSummary: getReviewPageSummaryQuery.data,
    isLoadingReviewPageSummary: getReviewPageSummaryQuery.isFetching,
    getReviewPageSummary: getReviewPageSummaryQuery.refetch,
    reviewPageSummaryError: getReviewPageSummaryQuery.error,
  };
};